import { render, staticRenderFns } from "./receiptsConfirms.vue?vue&type=template&id=1d649c7b&scoped=true&"
import script from "./receiptsConfirms.vue?vue&type=script&lang=js&"
export * from "./receiptsConfirms.vue?vue&type=script&lang=js&"
import style0 from "./receiptsConfirms.vue?vue&type=style&index=0&id=1d649c7b&lang=less&scoped=true&"
import style1 from "./receiptsConfirms.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d649c7b",
  null
  
)

component.options.__file = "receiptsConfirms.vue"
export default component.exports